import { PhotoErrorNotice } from './PhotoErrorNotice';
import type { PhotoLayout } from './use-photo-layout';
import type { VenuePhotoFlow } from './use-venue-photo-flow';

/** The error notice for the flow's latest problem, if any. A new attempt always shows (and is announced) afresh. */
export function PhotoProblemNotice({
  flow,
  layout,
}: {
  flow: VenuePhotoFlow;
  layout: PhotoLayout;
}) {
  const { problem } = flow;
  if (!problem) return null;
  return (
    <PhotoErrorNotice
      key={problem.attempt}
      message={problem.message}
      fileLabel={problem.fileLabel}
      phone={layout.phone}
      focusRequested={flow.focusTarget === 'problem'}
      onFocused={flow.focusDone}
      onDismiss={flow.dismissProblem}
    />
  );
}
